/** Two-dimensional vectors, as plain data. */
import { Vec2 } from './types';

export const v = (x: number, y: number): Vec2 => ({ x, y });
export const add = (a: Vec2, b: Vec2): Vec2 => ({ x: a.x + b.x, y: a.y + b.y });
export const sub = (a: Vec2, b: Vec2): Vec2 => ({ x: a.x - b.x, y: a.y - b.y });
export const scale = (a: Vec2, k: number): Vec2 => ({ x: a.x * k, y: a.y * k });
export const dot = (a: Vec2, b: Vec2): number => a.x * b.x + a.y * b.y;
export const len = (a: Vec2): number => Math.hypot(a.x, a.y);

/** Unit vector, or (0,0) for a zero-length input — callers check. */
export const unit = (a: Vec2): Vec2 => {
    const L = len(a);
    return L < 1e-12 ? { x: 0, y: 0 } : { x: a.x / L, y: a.y / L };
};

/** y runs UP: the floor is small y, the ceiling large. */
export const DOWN: Vec2 = { x: 0, y: -1 };
export const ACROSS: Vec2 = { x: 1, y: 0 };

/** Is this direction (anti)parallel to straight down? The timeline is exact
 *  only when every axis and every rope run is, so it is worth asking. */
export const isVertical = (a: Vec2, tol = 1e-6): boolean => Math.abs(a.x) < tol;
